import React, {useRef} from 'react';
import './style.scss';
import {BigGreenButton} from '../BigGreenButton';
import {FullScreenOverlay} from "../FullScreenOverlay";

export const Popup = ({children, title, buttonText, fullHeight, onButtonClick, onClose, closed}) => {
    const refPopup = useRef();

    const closePopup = () => {
        refPopup.current.classList.remove('app-animation');
        window.setTimeout(() => onClose(), 256);
    }

    return <>
        <FullScreenOverlay/>
        <article ref={refPopup} className={'app-popup' + (fullHeight ? ' app-popup_fh' : '') + (closed ? '' : ' app-animation')}>
            <header className="app-popup--header">
                <span>{title}</span>
                <svg
                    onClick={() => closePopup()}
                    width="20" height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path d="M4.15758 3.32458C3.9918 3.32462 3.82981 3.37411 3.6923 3.4667C3.55479 3.5593 3.44802 3.6908 3.38564 3.84439C3.32326 3.99798 3.3081 4.16669 3.3421 4.32894C3.37611 4.4912 3.45773 4.63962 3.57653 4.75525L8.82067 9.99939L3.57653 15.2435C3.49655 15.3203 3.4327 15.4123 3.38871 15.5141C3.34472 15.6158 3.32148 15.7254 3.32036 15.8362C3.31923 15.9471 3.34023 16.0571 3.38214 16.1597C3.42405 16.2624 3.48602 16.3556 3.56441 16.434C3.64281 16.5124 3.73607 16.5744 3.83872 16.6163C3.94136 16.6582 4.05134 16.6792 4.16221 16.6781C4.27308 16.677 4.3826 16.6537 4.48438 16.6097C4.58615 16.5657 4.67812 16.5019 4.75491 16.4219L9.99905 11.1778L15.2432 16.4219C15.32 16.5019 15.412 16.5657 15.5137 16.6097C15.6155 16.6537 15.725 16.677 15.8359 16.6781C15.9468 16.6792 16.0567 16.6582 16.1594 16.6163C16.262 16.5744 16.3553 16.5124 16.4337 16.434C16.5121 16.3556 16.5741 16.2624 16.616 16.1597C16.6579 16.0571 16.6789 15.9471 16.6778 15.8362C16.6766 15.7254 16.6534 15.6158 16.6094 15.5141C16.5654 15.4123 16.5016 15.3203 16.4216 15.2435L11.1774 9.99939L16.4216 4.75525C16.542 4.63819 16.6242 4.48749 16.6575 4.32289C16.6908 4.15829 16.6736 3.98747 16.6082 3.83282C16.5427 3.67816 16.4321 3.54689 16.2908 3.4562C16.1494 3.36551 15.984 3.31963 15.8161 3.32458C15.5996 3.33103 15.3941 3.42151 15.2432 3.57686L9.99905 8.821L4.75491 3.57686C4.67725 3.49703 4.58438 3.43358 4.48179 3.39025C4.37919 3.34692 4.26895 3.32459 4.15758 3.32458Z" fill="#A89EAE"/>
                </svg>
            </header>
            <div className="app-popup--body">
                {children}
            </div>
            {!!buttonText.length && <footer className="app-popup--footer">
                <BigGreenButton onClick={() => typeof onButtonClick === 'function' ? onButtonClick() : closePopup()}>{buttonText}</BigGreenButton>
            </footer>}
        </article>
    </>;
}